import { useEffect } from "react";
import { useAuthState } from "../../../../MainComponents/GlobalContext";
import { useForm } from "react-hook-form";
import { useReducer } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faSpinner } from "@fortawesome/free-solid-svg-icons";

const UpdateAdminImage = ({ values }) => {
  const AuthState = useAuthState();

  function reducer(state, action) {
    switch (action.type) {
      case "setSubmitEditPhoto": {
        return {
          ...state,
          submitEditPhoto: action.payload,
        };
      }
      case "setUploadedImgSrc": {
        return {
          ...state,
          uploadedImgSrc: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitEditPhoto: {
      flag: "",
      dependency: false,
      data: {},
    },
    uploadedImgSrc: null,
  });

  const [EditPhotoSuccess, EditPhotoErrors, PhotoLoading] = useAxios(
    process.env.REACT_APP_ADMIN_CHANGE_PROFILE_PHOTO_API,
    "POST",
    state.submitEditPhoto.flag,
    state.submitEditPhoto.dependency,
    state.submitEditPhoto.data,
    true,
  );
  useEffect(() => {
    if (EditPhotoSuccess) {
      URL.revokeObjectURL(state.uploadedImgSrc);
    }
  }, [EditPhotoSuccess]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    watch,
  } = useForm({
    mode: "onChange",
    values,
  });
  useEffect(() => {
    const subscription = watch((input) => {
      if (input.profile_pic[0]?.name?.length > 0) {
        let imageUrl = URL.createObjectURL(input.profile_pic[0]);
        dispatch({
          type: "setUploadedImgSrc",
          payload: imageUrl,
        });
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [watch]);
  const onSubmit = (data) => {
    dispatch({
      type: "setSubmitEditPhoto",
      payload: {
        flag: "SubmitEditPhoto",
        dependency: !state.submitEditPhoto.dependency,
        data: { profile_pic: data.profile_pic[0] },
      },
    });
  };
  return (
    <form
      encType="multipart/form-data"
      method="post"
      onSubmit={handleSubmit(onSubmit)}
      className="admin-profile__card"
    >
      <div className="admin-profile__card-head">
        <h4 className="admin-profile__card-title">Profile Photo</h4>
        <p className="admin-profile__card-sub">
          Click the photo to choose a new profile picture
        </p>
      </div>

      <div className="admin-profile__avatar-wrap">
        <label htmlFor="profile_pic" className="admin-profile__avatar">
          <img
            src={
              state.uploadedImgSrc ||
              `https://api.our-matrix.com/uploads/profile_picture/${AuthState.userData?.admin?.profile_pic}`
            }
            alt="Admin Avatar"
          />
          <span className="admin-profile__avatar-overlay">
            <FontAwesomeIcon icon={faCamera} className="mr-1" />
            Change
          </span>
        </label>
        <p className="admin-profile__hint">JPG, PNG or WEBP — max 5MB</p>
        <input
          id="profile_pic"
          hidden
          type="file"
          accept="image/jpg, image/jpeg, image/png, image/webp"
          name="profile_pic"
          {...register("profile_pic", {
            required: true,
            validate: (value) => !(value[0]?.size > 5000000),
          })}
        />

        {errors.profile_pic && (
          <p className="admin-profile__error">
            {errors.profile_pic.type === "required" &&
              "Please choose a photo first."}
            {errors.profile_pic.type === "validate" && "Max Image Size is 5MB."}
          </p>
        )}
        {EditPhotoErrors?.response?.data?.errors?.profile_pic && (
          <p className="admin-profile__error">
            {EditPhotoErrors.response.data.errors.profile_pic[0]}
          </p>
        )}
      </div>

      <button
        disabled={!isValid || (state.submitEditPhoto.flag && PhotoLoading)}
        className="admin-profile__btn"
        type="submit"
      >
        {state.submitEditPhoto.flag && PhotoLoading ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          "Save Photo"
        )}
      </button>
    </form>
  );
};

export default UpdateAdminImage;
